import { useLoading, handleLoading } from "context/LoadingContext";
import { useMap } from "context/mapContext";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import api from "api";
import { NotificationManager } from "react-notifications";
import getEsriDataFromLayer from "context/contextFunctions/getEsriDataFromLayer";

const neededDomains = ["Actual_Workshop"];

export default function InstallationReport() {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();
  const [map] = useMap();
  const [, dispatchLoading] = useLoading();
  const [workshopsList, setWorkshopsList] = useState(null);
  const [munsList, setMunsList] = useState(null);

  const { govsList, unitsTable, view, munsLayer } = map;

  const onSubmit = async (data) => {
    handleLoading(dispatchLoading, true);
    if (data) {
      try {
        const reportsRes = await api.post(
          "reports/installation",
          {
            date: new Date(data.date),
            gov: data.gov ? data.gov.split(" ")[0] : null,
            mun: data.mun ? data.mun : null,
            workshopName: data.workshopName ? data.workshopName : null,
          },
          {
            responseType: "arraybuffer",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/pdf",
            },
          }
        );

        const url = window.URL.createObjectURL(new Blob([reportsRes.data]));
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", `${data.date}-Installation.pdf`);
        link.click();
      } catch (error) {
        console.log(error);
        if (error?.response?.status === 424)
          NotificationManager.error("No Reported Units For This Day");
        else NotificationManager.error("An Error Occured");
      }
    }
    handleLoading(dispatchLoading, false);
  };

  const handleChangeGov = async (e) => {
    handleLoading(dispatchLoading, true);
    try {
      const token = localStorage.getItem("token");
      if (view && token && munsLayer) {
        const govName = e.target.value;
        const { res: munsListRes } = await getEsriDataFromLayer({
          featureLayer: munsLayer,
          query: `Governorate_English_Name  LIKE '%${govName}%'`,
          view,
        });
        setMunsList(munsListRes);
      }
    } catch (error) {
      console.log(error);
    }
    handleLoading(dispatchLoading, false);
  };

  useEffect(() => {
    (async () => {
      handleLoading(dispatchLoading, true);
      try {
        const token = localStorage.getItem("token");
        if (unitsTable && view && token) {
          const { domains: unitsDomains } = await getEsriDataFromLayer({
            featureLayer: unitsTable,
            neededDomains,
          });
          setWorkshopsList(unitsDomains.Actual_Workshop);
        }
      } catch (error) {
        console.log(error);
      }
      handleLoading(dispatchLoading, false);
    })();
  }, [view, unitsTable]);

  return (
    <div className="violation">
      <h4>Installation Report</h4>
      <form
        id="installationReportForm"
        onSubmit={handleSubmit(onSubmit)}
        className="d-grid"
        style={{ gap: "20px" }}
      >
        <Form.Group className="input input-md" controlId="Installation_Date">
          <Form.Label className="required">Date</Form.Label>
          <Form.Control
            type="date"
            {...register("date", {
              required: "Please Select a Date",
            })}
          />
          {errors.date && (
            <Form.Text className="text-danger">{errors.date.message}</Form.Text>
          )}
        </Form.Group>
        <div className="select">
          <Form.Group>
            <Form.Label /* className="required" */>Governorate</Form.Label>
            <Form.Select
              defaultValue=""
              {...register("gov", {
                // required: "Please Select a Governorate",
                onChange: (e) => handleChangeGov(e),
              })}
            >
              <option value="">- Select -</option>
              {govsList?.length &&
                govsList?.map((item) => (
                  <option
                    key={item.OBJECTID}
                    value={item.Governorate_English_Name}
                  >
                    {item.Governorate_Arabic_Name}
                  </option>
                ))}
            </Form.Select>
            {errors.gov && (
              <Form.Text className="text-danger">
                {errors.gov.message}
              </Form.Text>
            )}
          </Form.Group>
        </div>

        <div className="select">
          <Form.Group>
            <Form.Label /* className="required" */>Municipality</Form.Label>
            <Form.Select
              defaultValue=""
              {...register("mun", {
                // required: "Please Select a Municipality",
              })}
            >
              <option value="">- Select -</option>
              {munsList?.length &&
                munsList?.map((item) => (
                  <option key={item.OBJECTID} value={item.Municipality_E_1}>
                    {item.Municipality_A_1}
                  </option>
                ))}
            </Form.Select>
            {errors.gov && (
              <Form.Text className="text-danger">
                {errors.gov.message}
              </Form.Text>
            )}
          </Form.Group>
        </div>

        <div className="select">
          <Form.Group>
            <Form.Label>Workshop</Form.Label>
            <Form.Select defaultValue="" {...register("workshopName")}>
              <option value="">- All -</option>
              {workshopsList?.length &&
                workshopsList?.map((item) => (
                  <option key={item.code} value={item.code}>
                    {item.name}
                  </option>
                ))}
            </Form.Select>
          </Form.Group>
        </div>
        <button className="btn btn--primary" type="submit">
          Generate
        </button>
      </form>
    </div>
  );
}
